<template>
  <div id="culture-story-view">
    <CultureNav />

    <main class="culture-story-shell">
      <v-container v-if="story">
        <v-btn outlined class="story-back" :to="{ name: 'reckon-way' }">
          <v-icon left>mdi-arrow-left</v-icon>
          The Reckon Way
        </v-btn>
        <DraftBanner v-if="story.status === 'draft'" />
        <TravelBlogArticle
          :post="story.article"
          :kicker="story.kicker || 'The Reckon Way Story'"
        />
      </v-container>

      <v-container v-else>
        <v-btn outlined class="story-back mb-6" :to="{ name: 'reckon-way' }">
          <v-icon left>mdi-arrow-left</v-icon>
          The Reckon Way
        </v-btn>
        <p class="missing-story">Story not found.</p>
      </v-container>
    </main>

    <AppFooter />
  </div>
</template>

<script>
import AppFooter from '../components/Footer.vue';
import TravelBlogArticle from '../components/TravelBlogArticle.vue';
import CultureNav from '../components/reckon-way/culture/CultureNav.vue';
import DraftBanner from '../components/draft/DraftBanner.vue';
import { cultureStoriesBySlug } from '../content/culture/stories';
import { canViewContent } from '../lib/draftMode';

export default {
  name: 'CultureStoryView',
  components: {
    AppFooter,
    CultureNav,
    DraftBanner,
    TravelBlogArticle,
  },
  computed: {
    story() {
      const slug = this.$route.params.storySlug;
      const source = cultureStoriesBySlug[slug]
        || this.$store.getters.visibleRemoteContent.narratives.find((item) => item.slug === slug);
      return source && canViewContent(
        source.status,
        this.$store.getters.draftModeEnabled,
        this.$store.getters.isAuthorizedReckonUser,
      ) ? source : null;
    },
  },
  watch: {
    story: {
      immediate: true,
      handler(story) {
        let robots = document.querySelector('meta[name="robots"]');
        if (!robots) {
          robots = document.createElement('meta');
          robots.setAttribute('name', 'robots');
          document.head.appendChild(robots);
        }
        robots.setAttribute('content', story?.status === 'draft' ? 'noindex,nofollow' : 'index,follow');
      },
    },
  },
};
</script>

<style scoped>
.culture-story-shell {
  background: #050505;
  min-height: 70vh;
  padding: 42px 0 72px;
}

.story-back {
  border-color: #424242 !important;
  color: #fff !important;
  margin-bottom: 34px;
}

.travel-blog {
  margin: 0 auto;
}

.missing-story {
  color: #c7c7c7;
  font-size: 1.1rem;
}
</style>
